export default ".wf-rows-name{line-height:1.5em;display:inline-block;vertical-align:middle;white-space:pre-line}";